const ACCESS_TOKEN = 'CLEOSCLIENT_accesstoken';
const TOKEN_ID = 'CLEOSCLIENT_tokenid';
const EXPIRES_AT = 'CLEOSCLIENT_expiresat';
const PERMISSIONS = 'CLEOSCLIENT_permissions';
const USERNAME = 'CLEOSCLIENT_username';
const NAME = 'CLEOSCLIENT_name';
const MENU_COLLAPSED = 'CLEOSCLIENT_menu_collapsed';
const MENU_EXPANDED_DOMAIN = 'CLEOSCLIENT_menu_expanded_domain';
const BEARER = 'bearer';
const ENTURUSER = 'CLEOSCLIENT_enturUser';

export const clear = () => {
  try {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(TOKEN_ID);
    localStorage.removeItem(EXPIRES_AT);
    localStorage.removeItem(PERMISSIONS);
    localStorage.removeItem(USERNAME);
    localStorage.removeItem(NAME);
    localStorage.removeItem(MENU_COLLAPSED);
    localStorage.removeItem(MENU_EXPANDED_DOMAIN);
    localStorage.removeItem(BEARER);
    localStorage.removeItem(ENTURUSER);
  } catch (e) {
    console.error(e);
  }
};
